// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__HIj9q","container":"Footer_container__krfbB","links":"Footer_links__kUTNW","socialLinks":"Footer_socialLinks__XSGIn","icon":"Footer_icon__TIeOl"};